// React Basic and Bootstrap
import React, { Component } from "react";
import { Row, Col, Card, CardBody, Collapse } from "reactstrap";
import "./Terms.css";

class Terms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      t1: true,
      t2: false,
      t3: false,
      t4: false,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  // Make sure to remove the DOM listener when the component is unmounted.
  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation);
  }

  scrollNavigation = () => {
    var doc = document.documentElement;
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (top > 80) {
      document.getElementById("topnav").classList.add("nav-sticky");
    } else {
      document.getElementById("topnav").classList.remove("nav-sticky");
    }
  };

  render() {
    return (
      <React.Fragment>
        <main className="bg-light terms-container">
          <div className="main">
            <div className="container mt-5 px-5">
              <Row className="justify-content-center mb-5">
                <Col lg={12} className="text-center">
                  <div className="page-next-level">
                    <h4 className="title"> Terms of Service </h4>
                    <p className="text-muted">Last updated: June 22, 2020</p>
                  </div>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col lg={9}>
                  <div className="p-4 shadow border rounded">
                    <p className="text-muted">
                      Please read these Terms of Service ("Terms", "Terms of
                      Service") carefully before using the https://backlogs.co
                      website (the "Service") operated by Lonely Dev Inc ("us",
                      "we", or "our").
                    </p>
                    <p className="text-muted">
                      Your access to and use of the Service is conditioned upon
                      your acceptance of and compliance with these Terms. These
                      Terms apply to all visitors, users and others who wish to
                      access or use the Service.
                    </p>
                    <p className="text-muted">
                      By accessing or using the Service you agree to be bound by
                      these Terms. If you disagree with any part of the terms
                      then you do not have permission to access the Service.
                    </p>

                    <h5>1. Communications</h5>
                    <p className="text-muted">
                      By creating an Account on our service, you agree to
                      subscribe to newsletters, marketing or promotional
                      materials and other information we may send.
                    </p>
                    <p className="text-muted">
                      However, you may opt out of receiving any, or all, of
                      these communications from us by following the unsubscribe
                      link or instructions provided in any email we send.
                    </p>

                    <h5>2. Subscriptions</h5>
                    <p className="text-muted">
                      Some parts of the Service are billed on a subscription
                      basis ("Subscription(s)"). You will be billed in advance
                      on a recurring and periodic basis ("Billing Cycle").
                      Billing cycles are set either on a monthly or annual
                      basis, depending on the type of subscription plan you
                      select when purchasing a Subscription.
                    </p>
                    <p className="text-muted">
                      At the end of each Billing Cycle, your Subscription will
                      automatically renew under the exact same conditions unless
                      you cancel it or Lonely Dev Inc cancels it. You may cancel
                      your Subscription renewal by contacting Lonely Dev Inc
                      customer support team.
                    </p>
                    <p className="text-muted">
                      A valid payment method, including credit card, is required
                      to process the payment for your Subscription. You shall
                      provide Lonely Dev Inc with accurate and complete billing
                      information including full name, address, state, zip code,
                      telephone number, and a valid payment method information.
                      By submitting such payment information, you automatically
                      authorize Lonely Dev Inc to charge all Subscription fees
                      incurred through your account to any such payment
                      instruments.
                    </p>
                    <p className="text-muted">
                      Should automatic billing fail to occur for any reason,
                      Lonely Dev Inc will issue an electronic invoice indicating
                      that you must proceed manually, within a certain deadline
                      date, with the full payment corresponding to the billing
                      period as indicated on the invoice.
                    </p>

                    <h5>3. Fee Changes</h5>
                    <p className="text-muted">
                      Lonely Dev Inc, in its sole discretion and at any time,
                      may modify the Subscription fees for the Subscriptions.
                      Any Subscription fee change will become effective at the
                      end of the then-current Billing Cycle.
                    </p>
                    <p className="text-muted">
                      Lonely Dev Inc will provide you with a reasonable prior
                      notice of any change in Subscription fees to give you an
                      opportunity to terminate your Subscription before such
                      change becomes effective.
                    </p>
                    <p className="text-muted">
                      Your continued use of the Service after the Subscription
                      fee change comes into effect constitutes your agreement to
                      pay the modified Subscription fee amount.
                    </p>
                    <h5>4. Refunds</h5>

                    <p className="text-muted">
                      Certain refund requests for Subscriptions may be
                      considered by Lonely Dev Inc on a case-by-case basis and
                      granted in sole discretion of Lonely Dev Inc.
                    </p>

                    <h5>5. Content</h5>
                    <p className="text-muted">
                      Our Service allows you to post, link, store, share and
                      otherwise make available certain information, text,
                      graphics, videos, or other material ("Content"). You are
                      responsible for the Content that you post on or through
                      the Service, including its legality, reliability, and
                      appropriateness.
                    </p>
                    <p className="text-muted">
                      By posting Content on or through the Service, You
                      represent and warrant that: (i) the Content is yours (you
                      own it) and/or you have the right to use it and the right
                      to grant us the rights and license as provided in these
                      Terms, and (ii) that the posting of your Content on or
                      through the Service does not violate the privacy rights,
                      publicity rights, copyrights, contract rights or any other
                      rights of any person or entity. We reserve the right to
                      terminate the account of anyone found to be infringing on
                      a copyright.
                    </p>
                    <p className="text-muted">
                      You retain any and all of your rights to any Content you
                      submit, post or display on or through the Service and you
                      are responsible for protecting those rights. We take no
                      responsibility and assume no liability for Content you or
                      any third party posts on or through the Service. However,
                      by posting Content using the Service you grant us the
                      right and license to use, modify, publicly perform,
                      publicly display, reproduce, and distribute such Content
                      on and through the Service. You agree that this license
                      includes the right for us to make your Content available
                      to other users of the Service, who may also use your
                      Content subject to these Terms.
                    </p>
                    <p className="text-muted">
                      Lonely Dev Inc has the right but not the obligation to
                      monitor and edit all Content provided by users.
                    </p>
                    <p className="text-muted">
                      In addition, Content found on or through this Service are
                      the property of Lonely Dev Inc or used with permission.
                      You may not distribute, modify, transmit, reuse, download,
                      repost, copy, or use said Content, whether in whole or in
                      part, for commercial purposes or for personal gain,
                      without express advance written permission from us.
                    </p>

                    <h5>6. Accounts</h5>
                    <p className="text-muted">
                      When you create an account with us, you guarantee that you
                      are above the age of 18, and that the information you
                      provide us is accurate, complete, and current at all
                      times. Inaccurate, incomplete, or obsolete information may
                      result in the immediate termination of your account on the
                      Service.
                    </p>
                    <p className="text-muted">
                      You are responsible for maintaining the confidentiality of
                      your account and password, including but not limited to
                      the restriction of access to your computer and/or account.
                      You agree to accept responsibility for any and all
                      activities or actions that occur under your account and/or
                      password, whether your password is with our Service or a
                      third-party service. You must notify us immediately upon
                      becoming aware of any breach of security or unauthorized
                      use of your account.
                    </p>
                    <p className="text-muted">
                      You may not use as a username the name of another person
                      or entity or that is not lawfully available for use, a
                      name or trademark that is subject to any rights of another
                      person or entity other than you, without appropriate
                      authorization. You may not use as a username any name that
                      is offensive, vulgar or obscene.
                    </p>
                    <p className="text-muted">
                      We reserve the right to refuse service, terminate
                      accounts, remove or edit content in our sole discretion.
                    </p>

                    <h5>7. Intellectual Property</h5>
                    <p className="text-muted">
                      The Service and its original content (excluding Content
                      provided by users), features and functionality are and
                      will remain the exclusive property of Lonely Dev Inc and
                      its licensors. The Service is protected by copyright,
                      trademark, and other laws of both the United States and
                      foreign countries. Our trademarks and trade dress may not
                      be used in connection with any product or service without
                      the prior written consent of Lonely Dev Inc.
                    </p>

                    <h5>8. Links To Other Web Sites</h5>
                    <p className="text-muted">
                      Our Service may contain links to third party web sites or
                      services that are not owned or controlled by Lonely Dev
                      Inc.
                    </p>
                    <p className="text-muted">
                      Lonely Dev Inc has no control over, and assumes no
                      responsibility for the content, privacy policies, or
                      practices of any third party web sites or services. We do
                      not warrant the offerings of any of these
                      entities/individuals or their websites.
                    </p>
                    <p className="text-muted">
                      You acknowledge and agree that Lonely Dev Inc shall not be
                      responsible or liable, directly or indirectly, for any
                      damage or loss caused or alleged to be caused by or in
                      connection with use of or reliance on any such content,
                      goods or services available on or through any such third
                      party web sites or services.
                    </p>
                    <p className="text-muted">
                      We strongly advise you to read the terms and conditions
                      and privacy policies of any third party web sites or
                      services that you visit.
                    </p>
                    <h5>9. Termination</h5>
                    <p className="text-muted">
                      We may terminate or suspend your account and bar access to
                      the Service immediately, without prior notice or
                      liability, under our sole discretion, for any reason
                      whatsoever and without limitation, including but not
                      limited to a breach of the Terms.
                    </p>
                    <p className="text-muted">
                      If you wish to terminate your account, you may simply
                      discontinue using the Service.
                    </p>
                    <p className="text-muted">
                      All provisions of the Terms which by their nature should
                      survive termination shall survive termination, including,
                      without limitation, ownership provisions, warranty
                      disclaimers, indemnity and limitations of liability.
                    </p>
                    <h5>10. Indemnification</h5>
                    <p className="text-muted">
                      You agree to defend, indemnify and hold harmless Lonely
                      Dev Inc and its licensee and licensors, and their
                      employees, contractors, agents, officers and directors,
                      from and against any and all claims, damages, obligations,
                      losses, liabilities, costs or debt, and expenses
                      (including but not limited to attorney's fees), resulting
                      from or arising out of a) your use and access of the
                      Service, by you or any person using your account and
                      password; b) a breach of these Terms, or c) Content posted
                      on the Service.
                    </p>

                    <h5>11. Limitation Of Liability</h5>
                    <p className="text-muted">
                      In no event shall Lonely Dev Inc, nor its directors,
                      employees, partners, agents, suppliers, or affiliates, be
                      liable for any indirect, incidental, special,
                      consequential or punitive damages, including without
                      limitation, loss of profits, data, use, goodwill, or other
                      intangible losses, resulting from (i) your access to or
                      use of or inability to access or use the Service; (ii) any
                      conduct or content of any third party on the Service;
                      (iii) any content obtained from the Service; and (iv)
                      unauthorized access, use or alteration of your
                      transmissions or content, whether based on warranty,
                      contract, tort (including negligence) or any other legal
                      theory, whether or not we have been informed of the
                      possibility of such damage, and even if a remedy set forth
                      herein is found to have failed of its essential purpose.
                    </p>

                    <h5>12. Disclaimer</h5>
                    <p className="text-muted">
                      Your use of the Service is at your sole risk. The Service
                      is provided on an "AS IS" and "AS AVAILABLE" basis. The
                      Service is provided without warranties of any kind,
                      whether express or implied, including, but not limited to,
                      implied warranties of merchantability, fitness for a
                      particular purpose, non-infringement or course of
                      performance.
                    </p>
                    <p className="text-muted">
                      Lonely Dev Inc its subsidiaries, affiliates, and its
                      licensors do not warrant that a) the Service will function
                      uninterrupted, secure or available at any particular time
                      or location; b) any errors or defects will be corrected;
                      c) the Service is free of viruses or other harmful
                      components; or d) the results of using the Service will
                      meet your requirements.
                    </p>

                    <h5>13. Exclusions</h5>
                    <p className="text-muted">
                      Some jurisdictions do not allow the exclusion of certain
                      warranties or the exclusion or limitation of liability for
                      consequential or incidental damages, so the limitations
                      above may not apply to you.
                    </p>
                    <h5>14. Governing Law</h5>
                    <p className="text-muted">
                      These Terms shall be governed and construed in accordance
                      with the laws of California, United States, without regard
                      to its conflict of law provisions.
                    </p>
                    <p className="text-muted">
                      Our failure to enforce any right or provision of these
                      Terms will not be considered a waiver of those rights. If
                      any provision of these Terms is held to be invalid or
                      unenforceable by a court, the remaining provisions of
                      these Terms will remain in effect. These Terms constitute
                      the entire agreement between us regarding our Service, and
                      supersede and replace any prior agreements we might have
                      had between us regarding the Service.
                    </p>
                    <h5>15. Changes</h5>
                    <p className="text-muted">
                      We reserve the right, at our sole discretion, to modify or
                      replace these Terms at any time. If a revision is material
                      we will provide at least 30 days notice prior to any new
                      terms taking effect. What constitutes a material change
                      will be determined at our sole discretion.
                    </p>
                    <p className="text-muted">
                      By continuing to access or use our Service after any
                      revisions become effective, you agree to be bound by the
                      revised terms. If you do not agree to the new terms, you
                      are no longer authorized to use the Service.
                    </p>
                    <h5>16. Contact Us</h5>
                    <p className="text-muted">
                      If you have any questions about these Terms, please
                      contact us at damon@lonely.dev.
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </main>
      </React.Fragment>
    );
  }
}
export default Terms;
